export interface IAuthority {
    name: string;
    description?: string;
    groupId?: number;
    userCount?: number;
}

export class Authority implements IAuthority {
    public description = '';
    public groupId?: number;
    public userCount?: number;

    constructor(
        public name: string,
    ) {}
}
  